$(document).ready(function() {
  $('.vcarousel-viewer').slick({ 
     slidesToShow: 1,
     slidesToScroll: 1,
     arrows: false,
     dots: false,
     adaptiveHeight: true,
     asNavFor: '.vcarousel-thumbgroup'
  });

  $('.vcarousel-thumbgroup').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    vertical:true,
    asNavFor: '.vcarousel-viewer',
    dots: false,
    arrows: false,
    focusOnSelect: true,
    verticalSwiping: true,
    responsive: [
      {
        breakpoint: 749,
        settings:{
          vertical: false
        }
      }
    ]
  });

  $(window).resize(function(){
    $('.vcarousel-thumbgroup')[0].slick.refresh();
  });
});